<template>
  <div>
    <div class="top">
      <div v-if="user_login" class="top_box">
        <img class="my_img" :src="user_img" alt="" />
        <div
          v-if="user_login"
          class="login"
          style="font-weight: 700; font-size: 18px"
        >
          {{ user_name }}
        </div>
      </div>
      <div v-else class="top_box">
        <img class="my_img" src="../../src/assets/no_login.png" alt="" />
        <div
          @click="login"
          class="login"
          style="font-weight: 700; font-size: 18px"
        >
          登录 / 注册
        </div>
      </div>
      <div style="display: flex; align-items: center; margin-top: 10px">
        <div class="my_title">
          <div class="number">0</div>
          <div class="title_name">积分</div>
        </div>
        <div class="my_title">
          <div class="number">0</div>
          <div class="title_name">优惠券</div>
        </div>
        <div class="my_title" style="border: none">
          <div class="number">￥0</div>
          <div class="title_name">账户余额</div>
        </div>
      </div>
    </div>
    <div class="my_between" @click="user_info">
      <div class="my_text">
        <div style="display: flex; align-items: center">
          <img class="my_icon" src="../../src//assets/user_mess.png" alt="" />
          <div style="color: #33363c; font-size: 15px; font-weight: 700">
            完善信息
          </div>
        </div>
        <img class="my_arrow" src="../../src/assets/arrow-right.png" alt="" />
      </div>
    </div>
    <div class="my_between" @click="cho_address">
      <div class="my_text">
        <div style="display: flex; align-items: center">
          <img class="my_icon" src="../../src/assets/address.png" alt="" />
          <div style="color: #33363c; font-size: 15px; font-weight: 700">
            收货地址
          </div>
        </div>
        <img class="my_arrow" src="../../src/assets/arrow-right.png" alt="" />
      </div>
    </div>
    <div class="my_between" @click="my_order">
      <div class="my_text">
        <div style="display: flex; align-items: center">
          <img class="my_icon" src="../../src/assets/dindan.png" alt="" />
          <div style="color: #33363c; font-size: 15px; font-weight: 700">
            我的订单
          </div>
        </div>
        <img class="my_arrow" src="../../src/assets/arrow-right.png" alt="" />
      </div>
    </div>
    <div class="my_between">
      <div class="my_text">
        <div style="display: flex; align-items: center">
          <img class="my_icon" src="../../src/assets/kefu.png" alt="" />
          <div style="color: #33363c; font-size: 15px; font-weight: 700">
            合作中心
          </div>
        </div>
        <img class="my_arrow" src="../../src/assets/arrow-right.png" alt="" />
      </div>
    </div>
    <div class="middle"></div>
    <div class="my_between">
      <div class="my_text">
        <div style="display: flex; align-items: center">
          <img class="my_icon" src="../../src/assets/yaoqin.png" alt="" />
          <div style="color: #33363c; font-size: 15px; font-weight: 700">
            邀请分享
          </div>
        </div>
        <img class="my_arrow" src="../../src/assets/arrow-right.png" alt="" />
      </div>
    </div>
    <div class="middle" style="margin-bottom: 20px"></div>
    <van-divider
      :style="{
        color: '#9c9e9f',
        borderColor: '#b5b3b3',
        padding: '0 16px',
        marginBottom: '30px',
        marginTop: '20px',
      }"
      >产品推荐</van-divider
    >
    <div class="new_p">
      <div class="item" v-for="(item, index) in new_products" :key="index">
        <!-- 图片 -->
        <div class="image">
          <img :src="https + item.image" alt="" />
        </div>
        <!-- 名称和价格 -->
        <div class="info">
          <div class="name">{{ item.title }}</div>
          <div class="price">￥{{ item.price }}</div>
        </div>
        <!-- 简介 -->
        <div class="intro">
          {{ item.synopsis }}
        </div>
      </div>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from "../../src/components/my_tabbar.vue";
import { my } from "@/utils/request";
import axios from "axios";
export default {
  data() {
    return {
      user_login: false,
      user_img: "",
      https: "",
      new_products: [],
    };
  },
  components: {
    Tabbar,
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    //完善信息
    user_info() {
      this.$router.push("/user_info");
    },
    //收获地址
    cho_address() {
      this.$router.push("/address");
    },
    //订单中心
    my_order() {
      this.$router.push("/order_list");
    },
  },
  async mounted() {
    if (localStorage.getItem("auth_token")) {
      this.user_login = true;
    }
    if (localStorage.getItem("user_info")) {
      this.user_name = JSON.parse(localStorage.getItem("user_info")).name;
      this.user_img = JSON.parse(localStorage.getItem("user_info")).userImage;
    }

    this.https = axios.defaults.baseURL; //获取axios的baseURL
    //发送网路请求
    const res = await my();
    //设置推荐数据
    this.new_products = res.data.data.products;
  },
};
</script>

<style scoped>
.header {
  font-family: "宋体";
}
.top {
  width: 95%;
  margin: 0 auto;
  background: #f7f8fa;
  border-radius: 10px;
  padding: 30px 5px 7px 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 6px #f5f3f3;
}
.top_box {
  display: flex;
  align-items: center;
  color: #000;
  font-size: 14px;
}
.my_img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  margin-right: 10px;
}

.my_title {
  width: 33%;
  height: 80rpx;
  border-right: 1px solid #cbc9c9;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 11px;
  justify-content: space-between;
  margin-top: 6px;
  color: #959292;
}
.number {
  font-size: 14px;
}
.title_name {
  font-size: 13px;
  margin-top: 6px;
  color: #4c4949;
}
.my_between {
  padding: 15px 16px;
  padding-left: 10px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #dcdbdb;
  margin-top: 10px;
}
.my_text {
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: space-between;
}
.my_icon {
  width: 26px;
  height: auto;
  margin-right: 20px;
}
.my_arrow {
  width: 14px;
  height: auto;
}
.middle {
  height: 5px;
  background: #f5f5f5;
}
.new_p {
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.info {
  display: flex;
  justify-content: space-between;
  padding: 6px 4px;
  padding-bottom: 0px;
}

.info .name {
  width: 85%;
  text-align: left;
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  font-size: 12px;
}
.price {
  font-weight: 700;
  font-size: 15px;
}

.item {
  width: 47%;
  margin-bottom: 14px;
}

.intro {
  text-align: left;
  color: #909090;
  font-size: 10px;
  line-height: 16px;
  padding: 0px 4px;
}
.image {
  width: 163px;
  height: 196px;
  background: #d6d4d4;
}
.image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>